import * as cssVariablesStyles from '../../css/var-export.scss';
import {LangKeyType} from '../../provider/locale/translation/type';
import {CommonPromotionStatusEnum, PromotionCatalogStatusEnum} from '../../service/promotions/promotions-type';
import {NeverError} from '../../util/error';

export function getPromotionStatusConfig(status: CommonPromotionStatusEnum): {
    langKey: LangKeyType;
    badgeColor: string;
    tagColor: string;
} {
    switch (status) {
        case CommonPromotionStatusEnum.Draft:
            return {
                langKey: 'PROMOTIONS__STATUS__DRAFT',
                badgeColor: cssVariablesStyles.gray7,
                tagColor: 'default',
            };
        case CommonPromotionStatusEnum.Planned:
            return {
                langKey: 'PROMOTIONS__STATUS__PLANNED',
                badgeColor: cssVariablesStyles.blue50,
                tagColor: 'blue',
            };
        case CommonPromotionStatusEnum.InProgress:
            return {
                langKey: 'PROMOTIONS__STATUS__IN_PROGRESS',
                badgeColor: cssVariablesStyles.orange50,
                tagColor: 'orange',
            };
        case CommonPromotionStatusEnum.Sent:
            return {
                langKey: 'PROMOTIONS__STATUS__SENT',
                badgeColor: cssVariablesStyles.blue50,
                tagColor: 'blue',
            };
        case CommonPromotionStatusEnum.Paused:
            return {
                langKey: 'PROMOTIONS__STATUS__PAUSED',
                badgeColor: cssVariablesStyles.orange50,
                tagColor: 'orange',
            };
        case CommonPromotionStatusEnum.Deleted:
            return {
                langKey: 'PROMOTIONS__STATUS__DELETED',
                badgeColor: cssVariablesStyles.danger50,
                tagColor: 'red',
            };
        default: {
            throw new NeverError(status);
        }
    }
}

export function getPromotionCatalogStatusConfig(status: PromotionCatalogStatusEnum): {
    langKey: LangKeyType;
    tagColor: string;
} {
    switch (status) {
        case PromotionCatalogStatusEnum.Active:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__ACTIVE', tagColor: 'green'};
        case PromotionCatalogStatusEnum.Planned:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__PLANNED', tagColor: 'blue'};
        case PromotionCatalogStatusEnum.Finished:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__FINISHED', tagColor: 'default'};
        case PromotionCatalogStatusEnum.Paused:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__PAUSED', tagColor: 'orange'};
        case PromotionCatalogStatusEnum.OnModeration:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__ON_MODERATION', tagColor: 'orange'};
        case PromotionCatalogStatusEnum.Rejected:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__REJECTED', tagColor: 'red'};
        case PromotionCatalogStatusEnum.Deleted:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__DELETED', tagColor: 'red'};
        case PromotionCatalogStatusEnum.Unknown:
            return {langKey: 'PROMOTIONS__CATALOG_STATUS__PENDING', tagColor: 'default'};
        default: {
            throw new NeverError(status);
        }
    }
}

export function getPromotionStatusFilterOptions(): Array<{value: CommonPromotionStatusEnum; langKey: LangKeyType}> {
    return [
        CommonPromotionStatusEnum.Draft,
        CommonPromotionStatusEnum.Planned,
        CommonPromotionStatusEnum.InProgress,
        CommonPromotionStatusEnum.Sent,
        CommonPromotionStatusEnum.Paused,
        CommonPromotionStatusEnum.Deleted,
    ].map((value) => ({value, langKey: getPromotionStatusConfig(value).langKey}));
}
